"use client";
import { useEffect, useRef } from "react";

const YearDropdown = ({ visible, style, options, selected, onSelect }) => {
  const popupref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupref.current && !popupref.current.contains(event.target)) {
        onSelect(null, true); // true = clicked outside
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [popupref, onSelect]);

  return (
    visible && (
      <div
        ref={popupref}
        className={`w-[170px] bg-white border border-gray-300 rounded-md overflow-y-scroll gk-scr p-[10px] position absolute z-10  top-[50px] left-[0px]  self-start`}
        style={style}
      >
        <div className="w-full overflow-y-scroll max-h-[120px]">
          {options.map((year, index) => (
            <div
              key={index}
              onClick={() => onSelect(year)}
              className={`flex flex-row items-center  w-full py-[5px] cursor-pointer hover:bg-themeColor hover:text-white text-textcolor hover:px-[10px] hover:rounded-xl`}
            >
              <p className=" font-medium text-sm ml-[10px]">
                {year}
              </p>
            </div>
          ))}
        </div>
      </div>
    )
  );
};

export default YearDropdown;
